/* Wheels Outlet: independent, eligible front/rear choices for a selected vehicle. */
(function (window, document) {
  'use strict';
  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function count(value) { return /^[1-9]\d*$/.test(String(value)) && Number(value) <= 100 ? Number(value) : null; }
  function create(settings) {
    var form = settings.form, data = settings.data;
    if (!window.fetch || !form.hasAttribute('data-wo-vehicle-form') || !window.WOVehicleCart || !window.WOVehicleCart.purchaseOptions) return null;
    window.WOVehicleCart.attach(form);
    var context = window.WOVehicleCart.purchaseOptions();
    if (!context || !context.axleOptions) return null;
    var vehicle = window.WOVehicleCart.properties();
    if (!vehicle.Vehicle || !vehicle['_Vehicle ID']) return null;
    var axes = ['front', 'rear'], states = {}, primary = context.axle;
    function title(axis) { return axis === 'front' ? 'Front wheels' : 'Rear wheels'; }
    function cash(cents) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' }).format(cents / 100); }
      catch (_) { return (cents / 100).toFixed(2) + ' ' + (data.currency || 'USD'); }
    }
    function label(variant) {
      return variant.options.map(function (value, index) {
        var name = String(data.options[index] || '').toLowerCase();
        if (/^(?:et|offset)(?:\s|$)/.test(name)) return 'ET' + String(value).replace(/^\s*ET\s*/i, '');
        return value;
      }).join(' · ');
    }
    axes.forEach(function (axis) {
      var eligible = data.variants.filter(function (variant) { return context.axleOptions[axis].indexOf(String(variant.id)) !== -1; });
      eligible.sort(function (a, b) { return label(a).localeCompare(label(b), undefined, { numeric: true }); });
      var linked = eligible.find(function (variant) { return String(variant.id) === context.variantId; });
      states[axis] = { variants: eligible, selected: axis === primary && linked ? linked : (eligible.find(function (variant) { return variant.available; }) || eligible[0] || null), enabled: axis === primary, quantity: '2' };
    });
    if (!states[primary] || !states[primary].selected || String(states[primary].selected.id) !== context.variantId) return null;
    var box = make('section', 'wo-staggered-purchase');
    box.setAttribute('aria-label', 'Choose front and rear wheels');
    var heading = make('div', 'wo-staggered-heading');
    heading.appendChild(make('h3', '', 'Build your wheel setup'));
    heading.appendChild(make('p', '', 'Choose front and rear wheels separately. Add one axle or both.'));
    box.appendChild(heading);
    function active() { return axes.filter(function (axis) { return states[axis].enabled; }); }
    function total() { return active().reduce(function (sum, axis) { var s = states[axis]; return sum + (s.selected && count(s.quantity) ? s.selected.price * count(s.quantity) : 0); }, 0); }
    function wheelCount() { return active().reduce(function (sum, axis) { return sum + (count(states[axis].quantity) || 0); }, 0); }
    function selected() { return states[primary].enabled ? states[primary].selected : (active().length ? states[active()[0]].selected : states[primary].selected); }
    function update(axis) {
      if (states[axis].enabled) primary = axis;
      else if (!states[primary].enabled && active().length) primary = active()[0];
      render();
      settings.onChange(selected());
    }
    axes.forEach(function (axis) {
      var s = states[axis], prefix = 'wo-axle-' + data.id + '-' + axis;
      var card = make('div', 'wo-axle-purchase-card'); card.dataset.axle = axis;
      var head = make('div', 'wo-axle-purchase-head');
      var enableLabel = make('label', 'wo-axle-enable');
      var enable = make('input'); enable.type = 'checkbox'; enable.id = prefix + '-enabled'; enable.dataset.woAxleEnable = axis;
      enable.checked = s.enabled; enable.disabled = s.variants.length === 0;
      enable.hidden = !s.variants.length;
      if (!s.variants.length) { card.classList.add('is-unavailable'); enableLabel.classList.add('is-unavailable'); }
      enable.setAttribute('aria-controls', prefix + '-body');
      enableLabel.appendChild(enable); enableLabel.appendChild(make('span', '', title(axis)));
      head.appendChild(enableLabel); var badge = make('span', 'wo-axle-count'); head.appendChild(badge); card.appendChild(head);
      var body = make('div', 'wo-axle-purchase-body'); body.id = prefix + '-body';
      var optionLabel = make('label', '', 'Wheel configuration'); optionLabel.htmlFor = prefix + '-variant';
      var select = make('select', 'wo-axle-variant'); select.id = prefix + '-variant'; select.dataset.woAxleVariant = axis;
      s.variants.forEach(function (variant) {
        var option = make('option', '', label(variant) + (variant.available ? '' : ' — Out of stock'));
        option.value = String(variant.id); option.disabled = !variant.available; select.appendChild(option);
      });
      if (s.selected) select.value = String(s.selected.id);
      body.appendChild(optionLabel); body.appendChild(select);
      var details = make('div', 'wo-axle-details');
      var price = make('strong'), stock = make('span'); details.appendChild(price); details.appendChild(stock); body.appendChild(details);
      var quantityLabel = make('label', '', 'Quantity'); quantityLabel.htmlFor = prefix + '-quantity'; body.appendChild(quantityLabel);
      var quantityControls = make('div', 'wo-axle-quantity');
      var minus = make('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease ' + axis + ' wheel quantity');
      var input = make('input'); input.type = 'number'; input.inputMode = 'numeric'; input.min = '1'; input.max = '100'; input.step = '1'; input.value = s.quantity; input.id = prefix + '-quantity'; input.dataset.woAxleQuantity = axis;
      var plus = make('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase ' + axis + ' wheel quantity');
      quantityControls.appendChild(minus); quantityControls.appendChild(input); quantityControls.appendChild(plus); body.appendChild(quantityControls);
      var subtotal = make('div', 'wo-axle-subtotal'); body.appendChild(subtotal); card.appendChild(body);
      var unavailable = make('p', 'wo-staggered-note', 'This product has no matching ' + axis + ' configuration for your vehicle.'); unavailable.hidden = s.variants.length > 0;
      card.appendChild(unavailable);
      if (!s.variants.length) {
        var browse = make('a', 'wo-axle-browse', 'Find ' + axis + ' wheels');
        var url = new URL('/collections/wheels?view=vehicle', window.location.origin);
        url.searchParams.set('axle', axis);
        var details;
        try { details = JSON.parse(new URL(window.location.href).searchParams.get('wo_vehicle')); } catch (_) {}
        if (details && details.vehicle) Object.keys(details.vehicle).forEach(function (key) { url.searchParams.set(key, details.vehicle[key]); });
        var preview = new URL(window.location.href).searchParams.get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id', preview);
        browse.href = url.pathname + url.search;
        browse.addEventListener('click', function (event) {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !details || !details.vehicle || !details.labels) return;
          var destination = new URL(url.href);
          try {
            var nonce = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
            var keys = ['year', 'make', 'model', 'modification'];
            var detail = { vehicle: details.vehicle, labels: details.labels, label: keys.map(function (key) { return details.labels[key]; }).join(' ') };
            sessionStorage.setItem('wo-fitment:search-intent:v2', JSON.stringify({ nonce: nonce, timestamp: Date.now(), detail: detail }));
            destination.searchParams.set('intent', nonce);
          } catch (_) {}
          browse.href = destination.pathname + destination.search;
        });
        card.appendChild(browse);
      }
      s.nodes = { card: card, enable: enable, body: body, select: select, input: input, price: price, stock: stock, badge: badge, subtotal: subtotal };
      enable.addEventListener('change', function () { s.enabled = enable.checked; update(axis); });
      select.addEventListener('change', function () { s.selected = s.variants.find(function (variant) { return String(variant.id) === select.value; }) || null; update(axis); });
      input.addEventListener('input', function () { s.quantity = input.value; update(axis); });
      input.addEventListener('change', function () { s.quantity = input.value; update(axis); });
      function step(delta) { s.quantity = String(Math.min(100, Math.max(1, (count(s.quantity) || 1) + delta))); input.value = s.quantity; update(axis); }
      minus.addEventListener('click', function () { step(-1); }); plus.addEventListener('click', function () { step(1); });
      box.appendChild(card);
    });
    var totalBox = make('div', 'wo-staggered-total');
    var totalLabel = make('span', '', 'Selected wheels total'), totalPrice = make('strong'); totalBox.appendChild(totalLabel); totalBox.appendChild(totalPrice); totalBox.setAttribute('aria-live', 'polite'); box.appendChild(totalBox);
    box.appendChild(make('p', 'wo-staggered-note', 'Prices are per wheel. Confirm your front and rear setup before ordering.'));
    var originalOptions = form.querySelector('.modal-body');
    var originalQuantity = form.querySelector('.wo-purchase-actions .product-quantity');
    var originalTotal = form.querySelector('.summary > .total');
    var originalHint = form.querySelector('.wo-qty-hint');
    if (!originalOptions) return null;
    originalOptions.setAttribute('data-wo-original-options', '');
    if (originalQuantity) originalQuantity.setAttribute('data-wo-original-actions-quantity', '');
    if (originalTotal) originalTotal.setAttribute('data-wo-original-total', '');
    if (originalHint) originalHint.setAttribute('data-wo-original-hint', '');
    form.insertBefore(box, originalOptions);
    form.dataset.woStaggered = 'true';
    function render() {
      axes.forEach(function (axis) {
        var s = states[axis], n = s.nodes, v = s.selected;
        n.card.classList.toggle('is-active', s.enabled); n.body.hidden = !s.enabled || !s.variants.length;
        n.body.querySelectorAll('select, input, button').forEach(function (control) { control.disabled = n.body.hidden; });
        n.enable.setAttribute('aria-expanded', String(!n.body.hidden));
        n.badge.textContent = !s.variants.length ? 'No match' : (s.enabled ? ((count(s.quantity) || 0) + ' wheels') : 'Optional');
        n.price.textContent = v ? cash(v.price) + ' / wheel' : '';
        n.stock.textContent = !v || !v.available ? 'Out of stock' : (v.tracked && v.inventory < (count(s.quantity) || 1) ? (v.continueSelling ? 'Back order — call for ETA' : 'Selected quantity exceeds stock') : 'Available to order');
        n.subtotal.textContent = 'Subtotal ' + cash(v && count(s.quantity) ? v.price * count(s.quantity) : 0);
      });
      totalPrice.textContent = cash(total());
      totalLabel.textContent = wheelCount() + ' wheels · total';
    }
    function ready() { return active().length > 0 && active().every(function (axis) { var s = states[axis]; return s.selected && s.selected.available; }); }
    function buildItems(properties) {
      if (properties.Vehicle !== vehicle.Vehicle || properties['_Vehicle ID'] !== vehicle['_Vehicle ID']) return { error: 'Your vehicle changed. Return to vehicle search to choose wheels for the new vehicle.' };
      if (!active().length) return { error: 'Choose front wheels, rear wheels, or both.' };
      var items = [], inventory = {}, error = null;
      active().forEach(function (axis) {
        var s = states[axis], v = s.selected, qty = count(s.quantity);
        if (!v || !v.available || s.variants.indexOf(v) === -1) { error = title(axis) + ': choose an available configuration.'; return; }
        if (!qty) { error = title(axis) + ': choose a whole-number quantity from 1 to 100.'; return; }
        inventory[String(v.id)] = (inventory[String(v.id)] || 0) + qty;
        var props = Object.assign({}, properties, { Axle: axis === 'front' ? 'Front' : 'Rear' });
        // Backorder belongs to this exact line, never inherited from the other axle.
        delete props.order;
        items.push({ id: v.id, quantity: qty, properties: props });
      });
      if (error) return { error: error };
      items.forEach(function (item) {
        var v = data.variants.find(function (variant) { return String(variant.id) === String(item.id); });
        if (v.tracked && inventory[String(v.id)] > v.inventory) {
          if (v.continueSelling === false) error = 'There are not enough wheels in this configuration for your combined quantity. Reduce the quantity or choose another option.';
          else item.properties.order = 'Back order';
        }
      });
      return error ? { error: error } : { items: items };
    }
    function url(href) {
      var location = new URL(href), v = selected();
      if (!v || !active().length) return location.pathname + location.search + location.hash;
      try {
        var payload = JSON.parse(location.searchParams.get('wo_vehicle'));
        payload.axle = primary; payload.variantId = String(v.id);
        location.searchParams.set('wo_vehicle', JSON.stringify(payload)); location.searchParams.set('variant', String(v.id));
      } catch (_) {}
      return location.pathname + location.search + location.hash;
    }
    render();
    return { total: total, wheelCount: wheelCount, selected: selected, ready: ready, buildItems: buildItems, url: url };
  }
  window.WOStaggeredPurchase = Object.freeze({ create: create });
})(window, document);
